import React, { useEffect, useState } from 'react';
import PageContent from '../../components/layout/PageContent';
import axios from 'axios';
import CustomForm from '../../components/form/CustomForm';
import { useHistory } from 'react-router';

const AddRole = () => {

	const [ fields, setFields ] = useState([]);
	const [ loadingFields, setLoadingFields ] = useState(false);

	const history = useHistory();

	useEffect(() => {
		setLoadingFields(true);
		axios.get(`/api/1.0/role`)
		.then(({ data = {} }) => {
			const { result = [] } = data;
			setFields(result);
		})
		.catch(err => {
			console.error('Fetch Role Fields: ', err);
		})
		.finally(() => setLoadingFields(false))
	}, []);

	const handleSubmit = values => {
		return axios.post(`/api/1.0/role`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/role');
			}
		})
		.catch(err => {
			console.error('Create Role: ', err);
		})
	}

	const handleCancel = () => {
		history.push('/role')
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Роль үүсгэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				loading={loadingFields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default AddRole;